import { render, staticRenderFns } from "./OrderChip.vue?vue&type=template&id=0c892674&scoped=true&"
import script from "./OrderChip.vue?vue&type=script&lang=js&"
export * from "./OrderChip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c892674",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VChip,VIcon})


/* hot reload */
if (module.hot) {
  var api = require("/srv/dev/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c892674')) {
      api.createRecord('0c892674', component.options)
    } else {
      api.reload('0c892674', component.options)
    }
    module.hot.accept("./OrderChip.vue?vue&type=template&id=0c892674&scoped=true&", function () {
      api.rerender('0c892674', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TravelService/OrderChip.vue"
export default component.exports